export default __webpack_public_path__ + "static/media/Download.22baef53.svg";